// extracted by mini-css-extract-plugin
module.exports = {"tipText":"menu-form_tipText_2flo5"};